import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { LIST_CARD_BASE_CLASSNAME } from './Constants';
import { createListCard } from './ListCard';
createComponents(".".concat(LIST_CARD_BASE_CLASSNAME), createListCard, NO_PATTERN_BUSINESS_LOGIC);
